<div class="approvals-grid">
  <app-page-data-panel
    title="My leave approvals"
    subtitle="Track the status of your own leave requests."
    [resultText]="(workspace?.leaveRequests?.length || 0) + ' requests'">
    @if (workspace?.leaveRequests?.length) {
      <p-table [value]="workspace?.leaveRequests || []" responsiveLayout="stack" breakpoint="768px">
        <ng-template pTemplate="header">
          <tr>
            <th>Leave</th>
            <th>Period</th>
            <th>Status</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-request>
          <tr>
            <td><span class="p-column-title">Leave</span>{{ request.leaveName || request.leaveCode }}</td>
            <td><span class="p-column-title">Period</span>{{ request.startDate | date:'mediumDate' }} - {{ request.endDate | date:'mediumDate' }}</td>
            <td><span class="p-column-title">Status</span><p-tag [value]="label(request.requestStatus)" [severity]="statusSeverity(request.requestStatus)"></p-tag></td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <p class="empty-state">No leave approval history yet.</p>
    }
  </app-page-data-panel>

  <app-page-data-panel
    title="My expense approvals"
    subtitle="Expense claims and where they currently stand."
    [resultText]="(workspace?.expenses?.length || 0) + ' claims'">
    @if (workspace?.expenses?.length) {
      <p-table [value]="workspace?.expenses || []" responsiveLayout="stack" breakpoint="768px">
        <ng-template pTemplate="header">
          <tr>
            <th>Claim</th>
            <th>Amount</th>
            <th>Status</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-expense>
          <tr>
            <td><span class="p-column-title">Claim</span>{{ expense.description || expense.expenseNumber || ('Expense #' + expense.expenseId) }}</td>
            <td><span class="p-column-title">Amount</span>{{ expense.totalAmount | currency:(expense.currencyCode || 'SAR'):'symbol':'1.0-2' }}</td>
            <td><span class="p-column-title">Status</span><p-tag [value]="label(expense.status)" [severity]="statusSeverity(expense.status)"></p-tag></td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <p class="empty-state">No expense approval history yet.</p>
    }
  </app-page-data-panel>
</div>

<div class="approvals-grid">
  <app-page-data-panel
    title="My timesheet status"
    subtitle="Submitted or draft timesheets affecting approvals."
    [resultText]="(workspace?.timesheets?.length || 0) + ' timesheets'">
    @if (workspace?.timesheets?.length) {
      <p-table [value]="workspace?.timesheets || []" responsiveLayout="stack" breakpoint="768px">
        <ng-template pTemplate="header">
          <tr>
            <th>Period</th>
            <th>Status</th>
            <th>Hours</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-timesheet>
          <tr>
            <td><span class="p-column-title">Period</span>{{ timesheet.periodStart | date:'mediumDate' }} - {{ timesheet.periodEnd | date:'mediumDate' }}</td>
            <td><span class="p-column-title">Status</span><p-tag [value]="label(timesheet.timesheetStatus)" [severity]="statusSeverity(timesheet.timesheetStatus)"></p-tag></td>
            <td><span class="p-column-title">Hours</span>{{ (timesheet.regularHours || 0) + (timesheet.overtimeHours || 0) }}</td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <p class="empty-state">No timesheet approvals pending.</p>
    }
  </app-page-data-panel>

  @if (canViewManager || canApproveExpenses) {
    <app-page-data-panel
      title="Awaiting my decision"
      subtitle="Manager and expense queues routed to you."
      [resultText]="((workspace?.managerApprovals?.length || 0) + (workspace?.expenseApprovals?.length || 0)) + ' pending'">
      @if ((workspace?.managerApprovals?.length || 0) > 0) {
        <div class="queue-block">
          <h4>Manager queue</h4>
          <p-table [value]="workspace?.managerApprovals || []" responsiveLayout="stack" breakpoint="768px">
            <ng-template pTemplate="header">
              <tr>
                <th>Employee</th>
                <th>Request</th>
                <th>Status</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr>
                <td><span class="p-column-title">Employee</span>{{ item.employeeName || item.employeeNumber }}</td>
                <td><span class="p-column-title">Request</span>{{ item.title || label(item.approvalType) }}</td>
                <td><span class="p-column-title">Status</span><p-tag [value]="label(item.status)" [severity]="statusSeverity(item.status)"></p-tag></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }

      @if ((workspace?.expenseApprovals?.length || 0) > 0) {
        <div class="queue-block">
          <h4>Expense approvals</h4>
          <p-table [value]="workspace?.expenseApprovals || []" responsiveLayout="stack" breakpoint="768px">
            <ng-template pTemplate="header">
              <tr>
                <th>Expense</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-expense>
              <tr>
                <td><span class="p-column-title">Expense</span>{{ expense.description || expense.expenseNumber || ('Expense #' + expense.expenseId) }}</td>
                <td><span class="p-column-title">Amount</span>{{ expense.totalAmount | currency:(expense.currencyCode || 'SAR'):'symbol':'1.0-2' }}</td>
                <td><span class="p-column-title">Status</span><p-tag [value]="label(expense.status)" [severity]="statusSeverity(expense.status)"></p-tag></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }

      @if ((workspace?.managerApprovals?.length || 0) === 0 && (workspace?.expenseApprovals?.length || 0) === 0) {
        <p class="empty-state">Nothing is waiting for your decision right now.</p>
      }
    </app-page-data-panel>
  }
</div>
